import {openDB} from "idb";
// import moment from 'moment';

const storeNames = [
  {
    name: 'news',
    keyPath: null,
    indexes: [
      'createdAt',
    ],
  },
  // 'routeList',
  {
    name: 'routeDetail',
    keyPath: 'routeid',
    indexes: [
      'updatedAt',
    ],
  },
  {
    name: 'history',
    keyPath: null,
    indexes: [
      'createdAt',
    ],
  },
];

let db;

export async function initDbStore() {
  // console.log('db: ', db);

  if (db) {
    return db;
  }

  db = await openDB('roadhk', 4, {
    async upgrade(db, oldVersion, newVersion, transaction) {
      console.log('route store upgrade');

      try {
        console.log('delete existing tables');

        deleteExistingStore({transaction, db}, storeNames);
      } catch (e) {
        console.log('delete table error', e);
      }

      await createStore(db, storeNames);
    },
  });

  return db;
}

function deleteExistingStore({transaction, db}, storeNames) {
  storeNames.map(x => {
    const {name} = x;

    try {
      if (transaction.objectStore(name)) {
        db.deleteObjectStore(name);
      }
    } catch (e) {
      console.log(e);
    }
  });
}

async function createStore(db, storeNames) {
  const promises = storeNames.map(async x => {
    const {
      name, keyPath,
      indexes,
    } = x;

    try {
      let params = {};

      if (keyPath) {
        params = {
          ...params,
          keyPath,
        };
      } else {
        // default primary key
        params = {
          ...params,
          // The 'id' property of the object will be the key.
          keyPath: 'id',
          // If it isn't explicitly set, create a value by auto incrementing.
          autoIncrement: true,
        }
      }

      const store = await db.createObjectStore(name, params);

      indexes.map(index => {
        store.createIndex(index, index);
      })
    } catch (e) {
      console.log(e);
    }
  });

  return Promise.all(promises);
}
